/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SecondLine/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function SecondLine({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Patient/Content/PatientSearch/Results/Content/Option/SecondLine"
  
}) {
let personValueData = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromHelpers.getText,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textOverflow="none"
 overflowX="visible"
 color={dtColorsNeutral500}
 data="person"
 format="helpers.js getText"
 text={personValueData}
/>
{children}
</React.Fragment>)
}